export default __webpack_public_path__ + "static/romain-883962485067f502da63b8377e77a3e0.jpeg";